import { __awaiter } from "tslib";
import { getVisibleSymbolsInLayout } from 'shared/utils/ad';
import debug from 'shared/utils/debug';
/**
 * Specify the plugin file need to be loaded in production code
 */
const pluginLoaders = {
    video: () => import(/* webpackChunkName: "video" */ './videoManager'),
    carousel: () => import(/* webpackChunkName: "carousel" */ './carouselManager'),
};
/**
 * Load plugin based on symbol type
 * Promise to return only the symbol types that have the url loaded
 */
const loadPluginsBySymbolTypes = (ad, layoutId, isProof) => __awaiter(void 0, void 0, void 0, function* () {
    const loaders = getVisibleSymbolsInLayout(ad, layoutId)
        .map(sym => sym.type)
        // only type that has plugin url
        .filter(type => pluginLoaders[type])
        // unique
        .filter((val, idx, self) => self.indexOf(val) === idx)
        .map((symbolType) => __awaiter(void 0, void 0, void 0, function* () {
        debug(`Loading support file for plugin: ${symbolType}.`);
        const loader = pluginLoaders[symbolType];
        const loadedModule = yield loader();
        const pluginConstructor = 'default' in loadedModule ? loadedModule.default : loadedModule;
        const instance = new pluginConstructor();
        instance.setup(ad, layoutId, isProof);
        return { [symbolType]: instance };
    }));
    const loaderInstances = yield Promise.all(loaders);
    return loaderInstances.reduce((acc, record) => (Object.assign(Object.assign({}, acc), record)), {});
});
export default loadPluginsBySymbolTypes;
